import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getTournamentApiCall = createAsyncThunk("tournamentList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: tournamentList } = await API.getTournamentApi(submitData);
        //  console.log("*********************************************",letterList);
        dispatch(setLoader(false))
        return tournamentList;
    } catch (error) {
        throw error;
    }
});

export const editTournamentApiCall = createAsyncThunk("editTournamentListData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editTournamentData, code, message } = await API.updateTournamentApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editTournamentData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    tournamentList: {
        data: [],
        error: null,
    },
    editTournamentData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const TournamentSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTournamentApiCall.fulfilled, (state, action) => {
                state.tournamentList.data = action.payload;
            })
            .addCase(getTournamentApiCall.rejected, (state, action) => {
                state.tournamentList.error = action.error.message;
            })
            .addCase(editTournamentApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editTournamentData.data = data;
                state.editTournamentData.message = message;
                state.editTournamentData.code = code;
            })
            .addCase(editTournamentApiCall.rejected, (state, action) => {
                state.editTournamentData.error = action.error.message;
            });
    },
});

export default TournamentSlice.reducer;